// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { eye16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-eye': IconEye;
    }
}

/**
 * The icon component for the 'eye' icon
 */
export class IconEye extends Icon {
    public constructor() {
        super(eye16X16);
    }
}

registerIcon('icon-eye', IconEye);
export const iconEyeTag = 'nimble-icon-eye';
